import { render } from "./UniversalWrapper.vue?vue&type=template&id=cbc7dc34"
import script from "./UniversalWrapper.vue?vue&type=script&lang=js"
export * from "./UniversalWrapper.vue?vue&type=script&lang=js"

import "./UniversalWrapper.vue?vue&type=style&index=0&id=cbc7dc34&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__